var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokeBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 890,
    height: 890,
    viewBox: "0 0 890 890",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.812 422.423C755.242 358.476 731.211 295.323 686.885 242.43C574.904 108.805 375.8 91.2583 242.174 203.24C169.75 263.933 131.425 350.219 129.34 437.801L759.812 422.423ZM130.057 467.961C134.628 531.907 158.659 595.058 202.984 647.951C314.965 781.577 514.069 799.123 647.695 687.141C720.118 626.449 758.443 540.164 760.529 452.583L130.057 467.961Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.34 452.394C128.394 410.95 135.62 369.725 150.606 331.073C165.592 292.421 188.045 257.1 216.682 227.125C245.318 197.15 279.579 173.11 317.506 156.376C355.434 139.642 396.287 130.542 437.731 129.596C479.176 128.65 520.401 135.876 559.052 150.862C597.704 165.849 633.025 188.301 663 216.938C692.975 245.575 717.015 279.835 733.749 317.763C750.483 355.69 759.583 396.543 760.529 437.987L444.934 445.191L129.34 452.394Z",
    fill: "url(#paint0_linear_912_2277)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.34 452.394C128.394 410.95 135.62 369.725 150.606 331.073C165.592 292.421 188.045 257.1 216.682 227.125C245.318 197.15 279.579 173.11 317.506 156.376C355.434 139.642 396.287 130.542 437.731 129.596C479.176 128.65 520.401 135.876 559.052 150.862C597.704 165.849 633.025 188.301 663 216.938C692.975 245.575 717.015 279.835 733.749 317.763C750.483 355.69 759.583 396.543 760.529 437.987L444.934 445.191L129.34 452.394Z",
    fill: "url(#paint1_linear_912_2277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_2277",
    x1: 686.885,
    y1: 242.43,
    x2: 202.984,
    y2: 647.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1149DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_2277",
    x1: 686.885,
    y1: 242.43,
    x2: 202.984,
    y2: 647.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394DF",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3432AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeBall);
export default __webpack_public_path__ + "static/media/pokeBall.e15456c93f6a4670dfb72733c59940a9.svg";
export { ForwardRef as ReactComponent };